export default __webpack_public_path__ + "static/media/francheville21.f5faf25e.jpg";